import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'

import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '教えて！ 新潟のいいところ　#新潟のコメジルシ | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="#新潟のコメジルシ" />
      <SectionTitle sectionTitle="教えて！ 新潟のいいところ　#新潟のコメジルシ" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2024冬号 No.165 目次",
                path: "/no165"
              },
              {
                name: "#新潟のコメジルシ"
              }
            ]}
          />
        
        
        
        <p css={style.catchTxt}>コメジルシくんが「新潟が好きな理由」「新潟を選ぶ理由」を聞きました。</p>
        
        <img
          src={`${basePath}/no165/img/4-3.png`}
          alt="コメジルシくん"
          css={style.img(120, "15px 0 0 0")}
        />
        
        <p>
          <a
            href="https://howtoniigata.jp/komepro/"
            target="_blank"
            rel="noreferrer"
          >
            <span>新潟※（コメジルシ）プロジェクト&emsp;詳しくはこちら</span>
          </a>
        </p>
        
        <h3 css={style.subTitle01}>地域おこし協力隊<br />佐藤 和輝さん（小千谷市）</h3>
        
        <div>
          <img
            src={`${basePath}/no165/img/4-4.png`}
            alt="佐藤 和輝さん"
            css={style.img(500, "15px 0 0 0")}
          />
        </div>
        
        <p>令和4年から「錦鯉の海外輸出拡大」をテーマに活動しています。前職で小千谷市が錦鯉の産地であることを知る機会があり、日本発祥で歴史があって、なおかつ世界に向けてたくさん輸出していることに驚き、自分も何かで関わりたいと思っていたときに協力隊の募集を見つけたのが応募のきっかけです。<br />1年目から錦鯉サミットで世界各国からのお客様を迎えたり、輸入を考えたいというメキシコの大使館を訪問したりと、とてもグローバルな経験をしています。最近は生産者の皆さんからも仕事を依頼されるようになり、任期が終わった後は小千谷でこういう仕事をしてみたら、と言っていただくことも増えて、自分が必要とされていると感じられてうれしいです。2年目の今年度は情報発信に力を入れて、生産者の皆さんから聞くお話や動画などを世界に伝えていきたいと思っています。</p>
        
        <p>
          <a
            href="https://niigatakurashi.com/revitalization/"
            target="_blank"
            rel="noreferrer"
          >
            <span>地域おこし協力隊&emsp;詳しくはこちら</span>
          </a>
        </p>
        
        <BackBtn href={"/no165"} />
      </Content>
    </Page>
  )
}
export default Home
